export default __webpack_public_path__ + "static/media/clockIcon.cfa05a95.png";